import { Component, EventEmitter, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { SwalService } from "@shared/utils/swal.service";
import { Table } from "primeng/table";
import { AbcMonedasService } from "./services/abc-monedas.service";
import { IABCMoneda, IGetABCMonedasResp } from "./interfaces/IGetABCMonedas";
import { LoadingComponent } from "@app/theme/loading/loading.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Swal from "sweetalert2";
import { HelpersService } from "@shared/helpers/helpers.service";
import { element } from "protractor";

interface Column {
    field: string;
    header: string;
}
@Component({
    selector: "app-abc-monedas",
    templateUrl: "./abc-monedas.component.html",
    styleUrl: "./abc-monedas.component.css",
})
export class AbcMonedasComponent implements OnInit {
    @ViewChild("dt") table: Table;

    dataSource: any[] = [];
    handleModal: EventEmitter<void> = new EventEmitter<void>();

    dataModal: IABCMoneda = {} as IABCMoneda;

    valueToSearch: string = "";
    columns: Column[] = [
        { field: "moneda", header: "Moneda" },
        { field: "descripcion", header: "Descripción" },
        { field: "fecha_Ultima", header: "Fecha Alta" },
        { field: "factor", header: "Factor" },
        { field: "responsable", header: "Responsable" },
        { field: "actions", header: "Acciones" },
    ];

    constructor(
        private monedasService: AbcMonedasService,
        public loading: LoadingComponent,
        public _dialog: MatDialog,
        private _swalService: SwalService,
        public _helpers: HelpersService
    ) {}

    ngOnInit(): void {
        this.GetABCMonedas();
    }

    abrirModal(element: IABCMoneda) {
        console.log('ELEMTN',element);
        this.dataModal = element || ({} as IABCMoneda);
        this.handleModal.emit();
    }

    GetABCMonedas() {
        this.dataModal = {} as IABCMoneda;
        this.loading.openDialogLoading(true);
        this.monedasService.GetABCMonedas().subscribe({
            next: (res: IGetABCMonedasResp) => {
                this.loading.openDialogLoading(false);
                this.dataSource = res.data;
            },
            error: (err) => {
                console.log(err);
            },
        });
    }

    deleteMoneda(row: any) {
        Swal.fire({
            title: `¿Estas seguro de borrar la moneda ${row.moneda} | ${row.descripcion}?`,
            showCancelButton: true,
            iconColor: "#d33",
            icon: "warning",
            confirmButtonColor: "#d33",
            confirmButtonText: "Si",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                this.monedasService.DeleteABCMoneda(row.moneda).subscribe({
                    next: () => {
                        this._swalService.success("Moneda borrada exitosamente");
                        this.GetABCMonedas();
                    },
                    error: (err) => {
                        console.log(err);
                    },
                });
            }
        });
    }
}
